import { Link } from "react-router-dom";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Story, TipSection } from "../components/Sections";
import { Wall } from "../components/Wall";
import { ShareStudio } from "../components/ShareStudio";
import { Logo } from "../components/Brand";
import { AUTHOR } from "../lib/site";

const Footer = () => (
  <footer data-testid="site-footer" className="relative pt-24 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <p data-testid="footer-wordmark" className="font-serif-d italic text-[11vw] lg:text-[9rem] leading-[0.9] tracking-tight text-[#f4ede2]/[0.07] select-none">Bipolar Is Who I Am</p>
      <div className="mt-10 flex flex-col sm:flex-row justify-between gap-6 text-sm text-[#c4bbb0] border-t border-[#f4ede2]/10 pt-8">
        <div className="flex items-center gap-3"><Logo size={22} /> {AUTHOR.name} · Author of <em>{AUTHOR.book}</em></div>
        <div className="flex gap-6">
          <span>Payments by Square</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#e3ba73] transition-colors duration-300">Author login</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Story />
      <TipSection />
      <Wall />
      <ShareStudio />
      <Footer />
    </main>
  );
}
